// extracted by mini-css-extract-plugin
module.exports = {"container":"StoryLinks_container__QLAze","items":"StoryLinks_items__2oyMr","button":"StoryLinks_button__c7DtI","icon":"StoryLinks_icon__wylM7"};